import './SubmitButton.scss'
import React, { Component, PropTypes } from 'react'
import { throttle } from 'lodash'
import classnames from 'classnames'
import Button from '../Button'

// submit states
const SUBMIT_STATES = {
  DEFAULT: 'default',
  LOADING: 'loading',
  SUCCESS: 'success',
  FAILURE: 'failure'
}

class SubmitButton extends Component {
  constructor (props) {
    super(props)
    this.throttled = throttle(callback => callback(), 1000)
    this.handleLoading = this.handleLoading.bind(this)
    this.handleFailure = this.handleFailure.bind(this)
    this.handleSuccess = this.handleSuccess.bind(this)
    this.handleDefault = this.handleDefault.bind(this)
    this.state = { status: SUBMIT_STATES.DEFAULT }
  }

  componentWillReceiveProps (nextProps) {
    const { isSubmitting, submitFailure, submitSuccess } = nextProps
    if (isSubmitting !== this.props.isSubmitting) {
      if (isSubmitting) {
        this.throttled(this.handleLoading)
      } else if (submitFailure) {
        this.throttled(this.handleFailure)
      } else if (submitSuccess) {
        this.throttled(this.handleSuccess)
      } else {
        this.throttled(this.handleDefault)
      }
    }
  }

  componentWillUnmount () {
    this.throttled.cancel()
    clearTimeout(this.timeout)
  }

  handleLoading () {
    this.setState({ status: SUBMIT_STATES.LOADING })
  }

  handleDefault () {
    this.setState({ status: SUBMIT_STATES.DEFAULT })
  }

  handleSuccess () {
    this.setState({ status: SUBMIT_STATES.SUCCESS })
    this.timeout = setTimeout(() => {
      this.setState({ status: SUBMIT_STATES.DEFAULT })
    }, 1500)
  }

  handleFailure () {
    this.setState({ status: SUBMIT_STATES.FAILURE })
    this.timeout = setTimeout(() => {
      this.setState({ status: SUBMIT_STATES.DEFAULT })
    }, 1500)
  }

  handleClick (e) {
    if (this.state.status !== SUBMIT_STATES.LOADING) {
      this.props.onClick && this.props.onClick(e)
    }
  }

  render () {
    const className = classnames(
      'SubmitButton',
      `SubmitButton-${this.state.status}`,
      this.props.className
    )
    return (
      <Button {...this.props}
        className={className}
        disabled={!this.props.isValid}
        type='submit'>
        {this.renderStatus()}
      </Button>
    )
  }

  renderStatus () {
    switch (this.state.status) {
      case SUBMIT_STATES.LOADING: return 'Saving...'
      case SUBMIT_STATES.SUCCESS: return 'Saved!'
      case SUBMIT_STATES.FAILURE: return 'Failed'
      default: return this.props.children
    }
  }
}

SubmitButton.displayName = 'SubmitButton'

SubmitButton.propTypes = {
  isSubmitting: PropTypes.bool,
  submitFailure: PropTypes.any,
  submitSuccess: PropTypes.bool
}

export default SubmitButton



// WEBPACK FOOTER //
// ./src/lib/form/SubmitButton.js